import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StripedStyledRow = function StripedStyledRow(props) {
  return "\n    background-color: ".concat(props.theme.components.table.striped, ";\n");
};
export var StyledRow = styled.tr(_templateObject(), function (props) {
  return "\n        transition: ".concat(props.theme.components.table.transition, ";\n        border-bottom: 1px dashed ").concat(props.theme.components.table.borderColor, ";\n\n        &:last-child { \n            border-bottom: 0;\n        }\n\n        ").concat(props.striped ? StripedStyledRow(props) : '', "\n    ");
});